export const SET_LOADING = 'SET LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';

export const setLoading = () => ({
	type: SET_LOADING
});

export const hideLoading = () => ({
	type: HIDE_LOADING
});



// WEBPACK FOOTER //
// ./src/actions/loading.js